"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chevron = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faChevronRight_1 = require("@fortawesome/free-solid-svg-icons/faChevronRight");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_ui_1 = require("@yanzi/react-ui");
function Chevron(_a) {
    var { expanded, hidden } = _a, props = __rest(_a, ["expanded", "hidden"]);
    return (jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ px: 2, py: 1, display: "block", color: hidden ? 'transparent' : 'inherit', backgroundColor: "transparent", _hover: { backgroundColor: hidden ? 'transparent' : 'rgba(125,125,125,0.1)' }, disabled: !!hidden }, props, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: faChevronRight_1.faChevronRight, rotation: expanded ? 90 : undefined }, void 0) }), void 0));
}
exports.Chevron = Chevron;
//# sourceMappingURL=Chevron.js.map